import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SmoothScroll from "@/components/site/SmoothScroll";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import TrustBar from "@/components/site/TrustBar";
import Footer from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { PRODUCTS, SIZES, eur, coverOf } from "@/lib/shop";

function EshopTeaser() {
  const from = Math.min(...SIZES.map((s) => s.prices.unframed));
  return (
    <section className="bg-[#faf8f5] py-24 md:py-36" id="eshop-teaser">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.3em] text-[#a89f8e]">
            01 — Current Editions
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 max-w-4xl font-display text-3xl md:text-5xl lg:text-6xl leading-[1.03] tracking-tight text-[#111111]">
            The <span className="italic">X</span> Goes Here — in print.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xl text-base md:text-lg font-light leading-relaxed text-[#111111]/70">
            Numbered fine-art prints on Hahnemühle cotton paper. Framed or
            unframed, Noir or accent colourway.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l gallery-line">
          {PRODUCTS.slice(0, 3).map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.06} className="border-r border-b gallery-line">
              <Link to={`/shop/${p.id}`} className="group block" data-testid={`teaser-${p.id}`}>
                <div className="overflow-hidden bg-white">
                  <img
                    src={coverOf(p)}
                    alt={p.tagline}
                    loading={i > 0 ? "lazy" : undefined}
                    className="aspect-[4/5] w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.03]"
                  />
                </div>
                <div className="flex items-end justify-between gap-4 px-6 py-6">
                  <h3 className="font-display italic text-xl md:text-2xl tracking-tight text-[#111111]">
                    {p.name}
                  </h3>
                  <span className="text-sm font-light text-[#111111]/70">from {eur(from)}</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <Link
            to="/shop"
            data-testid="home-enter-eshop"
            className="mt-12 inline-flex items-center gap-2 border border-[#111111] px-7 py-4 text-sm font-light tracking-wide text-[#111111] hover:bg-[#111111] hover:text-[#faf8f5] transition-colors duration-500"
          >
            Discover the prints <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <SmoothScroll>
      <main className="bg-[#faf8f5]">
        <Nav />
        <Hero />
      <TrustBar />
        <Marquee
          items={[
            "The Picasso Goes Here",
            "The Basquiat Goes Here",
            "The Murakami Goes Here",
            "The Arsham Goes Here",
            "The Warhol Goes Here",
          ]}
          testId="marquee-top"
        />
        <EshopTeaser />
        <Footer />
      </main>
    </SmoothScroll>
  );
}
